import React, { useState, Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import MainSection from '../../components/sections/MainSection';
import APopover from '../../components/partials/APopover';
import { ToastContainer } from 'react-toastify';
import { Button } from '@material-tailwind/react';
import AMenu from '../../components/partials/AMenu';


const menuData = [
    { flag: "Renew", name: 'Renew', icon: 'create-outline', roles: [0], },
    { flag: "Close", name: 'Close', icon: 'remove-circle-outline', roles: [0] },
]

const TABLE_HEAD = ["#", "شماره / اسم ملکيت", 'نوعيت', 'مقدار پول به افغانی', "دوره صفايي",'انقضا' ,'تاریخ ایجاد', "اقدامات"];
const breadcrumbs = [{ name: 'صافیی ملکيت', link: '/rentals' }]

const searchInputFields = [
    { label: "شماره / اسم ملکيت", name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3' },
    { label: 'مقدار پول', name: 'amount', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },
    { label: 'از تاريخ', name: 'from_date', type: 'pdate', roles: [1], icon: 'book-outline', className: 'md:col-span-3' },
    { label: 'الی تاريخ', name: 'to_date', type: 'pdate', roles: [1], icon: 'book-outline', className: 'md:col-span-3' },
];


export default function Cleanliness() {

    const { com, setModel, models, navigate, setGeneratePDF, setShowViewDialog, showDeleteDialog, setShowDeleteDialog, setShowRentalCloseDialog, } = useShared();

    const handleMenu = (model, flag = false) => {
        console.log("handleMenu ", model, flag);
        setGeneratePDF(false)
        if (flag === 'delete') {
            setModel(model)
            setShowDeleteDialog(!showDeleteDialog)
        }
        if (flag === 'close') {
            if (model?.rental_items?.expiry && model?.rental_items?.status !== 3) {
                setModel(model)
                setShowRentalCloseDialog(true)
            }

        }
        if (flag === 'renew') {
            if (model?.rental_items?.expiry && model?.rental_items?.status !== 3)
                renew(model)
        }
        if (flag === 'view') {
            setModel(model)
            setShowViewDialog(true)
        }
    };

    const renew = (model) => {
        navigate(`/db/tariffs/0/new_tariff/0`, { state: { model, action: 'renew' } })
    }

    const getTableData = () => {
        const data = models?.data

        return (<><tbody className=' '>

            {data?.map((r, i) => {
                return (<Fragment key={i}>
                    {i < data?.length - 1 && <tr key={r.id} >
                        <td >{models?.from + i}</td>
                        <th className='text-left px-2'>{r?.company ? r?.company?.name_af : r?.name}</th>

                        <td style={{ direction: 'rtl' }}>
                            {r?.rental_items?.category?.label}
                            <APopover v={{ data: itemsPopup([r?.rental_items]), className: "mt-3", btn: '!bg-deep-purple-900/20', iconCss: '!text-deep-purple-500' }} />
                        </td>

                        <td> {com.NumberFormatter(r?.amount)} ؋</td>

                        <td>

                            <div className='ml-1'>{com.dateConvert(r?.rental_items?.from_date, false, false)} - {com.dateConvert(r?.rental_items?.to_date, false, false)} </div>

                        </td>
                        <td style={{ direction: 'rtl' }}>
                            {r?.rental_items?.status < 3 && r?.rental_items?.expiry ?
                                <Button onClick={() => renew(r)} className='bg-red-100 px-2 py-1 rounded-md text-main-color '>{r?.rental_items?.expiryDate} </Button> :
                                r?.rental_items?.status === 3 && r?.status === 2 ? <span className='bg-green-100 p-1 rounded-md text-green-900'>Renewed</span> :
                                    r?.rental_items?.status === 4 && r?.status === 2 ? <span className='bg-gray-100 p-1 rounded-md text-gray-800 ' >Closed</span> : r?.rental_items?.expiryDate}
                        </td>
                        <td style={{ direction: 'ltr' }} className='w-[20%]'>{com.dateConvert(r?.updated_at, false, true)}</td>
                        <td> <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} /></td>
                    </tr>}</Fragment>
                )
            })}

        </tbody>
            <tfoot>
                {data?.length > 0 && <tr className='border' key={data[data?.length - 1]?.id}>
                    <th className="bg-purple-500/20 text-purple-900"> توتال</th>
                    <th colSpan={7} className=" bg-green-400/30 text-green-900 text-lg font-bold">{com.NumberFormatter(data[data?.length - 1]?.amount)} ؋</th>
                </tr>}
            </tfoot>
        </>)
    }
    const itemsPopup = (items) => <table style={{ direction: 'rtl' }} className=" gTable  ">
        <thead >
            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>نام </th>
                <th> مقدار پول</th>
                <th>ادرس</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.tariff_amount} ؋</td>
                    <td> {item?.description} </td>

                </tr>
            ))}
        </tbody>
    </table>



    return (
        <>
            <MainSection v={{
                searchInputFields,
                TABLE_HEAD,
                tableData: getTableData(),
                breadcrumbs,
                tableTitle: 'لست ',
                mUrl: { getAll: 'cleanliness' },

            }} />

            <ToastContainer />
        </>

    )

}
